exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.currency .button{margin:0\n}\n.currency h4{background:#d5dde2;cursor:pointer;padding:10px 15px\n}\n.currency h4.open{background:#97a5ad;color:#fff\n}", ""]);

// exports
